import React, { memo } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { makeSelectNiveauFilterDataArray, makeSelectNiveauFilterId } from '../selectors';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import PillYellow, { PillText } from '../../../utils/Components/PillYellow';
import { setNiveauFilterDataArray, setNiveauFilterId } from '../actions';

const key = 'niveau';

export const FilterPills = ({
  niveauFilterId,
  niveauFilterDataArray,
  onSetNiveauFilterId,
  onSetNiveauFilterDataArray,
}) => {
  if (niveauFilterDataArray.length === 0) {
    return <></>;
  }

  const handlePillClick = (index) => {
    onSetNiveauFilterId([...niveauFilterId.slice(0, index), ...niveauFilterId.slice(index + 1)]);
    onSetNiveauFilterDataArray([
      ...niveauFilterDataArray.slice(0, index),
      ...niveauFilterDataArray.slice(index + 1),
    ]);
  };

  /**
   * Main return function.
   */
  return niveauFilterDataArray.map((item, index) => (
    <PillYellow key={`${key}_${item}`} onClick={() => handlePillClick(index)}>
      <PillText>{item}</PillText>
      <FontAwesomeIcon icon={faTimes} />
    </PillYellow>
  ));
};

FilterPills.propTypes = {
  niveauFilterId: PropTypes.array,
  niveauFilterDataArray: PropTypes.array,
  onSetNiveauFilterId: PropTypes.func,
  onSetNiveauFilterDataArray: PropTypes.func,
};

FilterPills.defaultProps = {
  niveauFilterId: [],
  niveauFilterDataArray: [],
  onSetNiveauFilterId: () => {},
  onSetNiveauFilterDataArray: () => {},
};

const mapStateToProps = createStructuredSelector({
  niveauFilterId: makeSelectNiveauFilterId(),
  niveauFilterDataArray: makeSelectNiveauFilterDataArray(),
});

export function mapDispatchToProps(dispatch) {
  return {
    onSetNiveauFilterId: (value) => dispatch(setNiveauFilterId(value)),
    onSetNiveauFilterDataArray: (value) => dispatch(setNiveauFilterDataArray(value)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, memo)(FilterPills);
